// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"CompanyStoreSettingForm_FormContainer__QCbXs","InvalidFeedback":"CompanyStoreSettingForm_InvalidFeedback__9tcsV"};